import { render, staticRenderFns } from "./UserAcceptTOS.vue?vue&type=template&id=37df7d9a&scoped=true"
import script from "./UserAcceptTOS.vue?vue&type=script&lang=js"
export * from "./UserAcceptTOS.vue?vue&type=script&lang=js"
import style0 from "./UserAcceptTOS.vue?vue&type=style&index=0&id=37df7d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df7d9a",
  null
  
)

export default component.exports